function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { defaultMarkdownParser, MarkdownParser as _MarkdownParser } from 'prosemirror-markdown';
import { createInlineVariableRule } from './utils';
import markdownit from 'markdown-it';
export class MarkdownParser {
  constructor(args) {
    _defineProperty(this, "variables", void 0);
    _defineProperty(this, "extensions", void 0);
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "parser", void 0);
    Object.assign(this, args);
    this.parser = new _MarkdownParser(this.schema, this.tokenizer, this.tokens);
  }
  parse(text) {
    return this.parser.parse(text);
  }
  get tokens() {
    const variableTokens = this.variables.reduce((acc, variable) => ({
      ...acc,
      [variable]: {
        node: variable
      }
    }), {
      invalidVariable: {
        node: 'invalidVariable'
      }
    });
    return {
      ...defaultMarkdownParser.tokens,
      ...variableTokens,
      pillbox: {
        node: 'pillbox',
        getAttrs: token => {
          const extension = this.extensions.findBy('token', token.meta);
          return {
            label: extension?.label || null,
            token: token.meta
          };
        }
      }
    };
  }
  get tokenizer() {
    const tokenizer = markdownit('commonmark', {
      html: false
    });

    // NOTE We need to add our custom rule before emphasis so that __USER__ will translate to our variable node
    tokenizer.inline.ruler.before('emphasis', 'markdown-it-variable', createInlineVariableRule(this.schema, this.variables), {
      alt: []
    });
    tokenizer.inline.ruler.push('markdown-it-extension', function (state) {
      // Matches "%{UI_HOOK|LOCATION_ID:1::UI_HOOK_ID:972281a8-a7a7-44d3-9631-9da3c4107122}"
      const match = state.src.slice(state.pos).match(/%\{\w+\|[\w\:\-]+\}/);
      const matchedToken = match && match[0];
      if (matchedToken) {
        state.pos = state.pos + matchedToken.length;
        const token = state.push('pillbox', 'span', 0);
        token.meta = matchedToken;
        return true;
      }
      return false;
    });
    return tokenizer;
  }
}